export const GET_LEADERSHIP_STAFF_DEVELOPMENT_SUCCESS =
  'GET_LEADERSHIP_STAFF_DEVELOPMENT_SUCCESS';
export const GET_LEADERSHIP_STAFF_DEVELOPMENT_FAILURE =
  'GET_LEADERSHIP_STAFF_DEVELOPMENT_FAILURE';

export const POST_LEADERSHIP_STAFF_DEVELOPMENT_SUCCESS =
  'POST_LEADERSHIP_STAFF_DEVELOPMENT_SUCCESS';
export const POST_LEADERSHIP_STAFF_DEVELOPMENT_FAILURE =
  'POST_LEADERSHIP_STAFF_DEVELOPMENT_FAILURE';
